// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressInfoItem_container__fzI3i","addressDetails":"AddressInfoItem_addressDetails__LDL-R","addresslabel":"AddressInfoItem_addresslabel__2hv0F"};